import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnFK: CultureInfo = {
  name: 'en-FK',
  displayName: 'English (Falkland Islands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-FK',
  parent: CultureInfoEn
};
